<template>
    <div>
        <div class="b_article_single">
            <div
                v-if="article.featuredImageId"
                v-full-background-image-path="article.featuredImage"
                class="article_banner bg_image cover"
            />

            <div class="container">
                <div class="article_wrapper">
                    <div class="wrapper_inner">
                        <article-navigation :items="paragraphs" />

                        <div class="article_section">
                            <div class="article_info">
                                <h1>{{ article.name }}</h1>
                            </div>

                            <div class="date_wrapper">
                                <span dir="rtl">
                                    עודכן לאחרונה
                                    {{ article.updatedAt | formatDate }}
                                </span>
                            </div>

                            <content-builder :value="article.content" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <recommended-articles />
    </div>
</template>

<script>
import { StatusCodes } from 'http-status-codes';
import headMixin from '@/mixins/head.mixin.js';
import ArticleNavigation from '@/components/articles/Navigation';
import ContentBuilder from '@/components/elements/ContentBuilder';
import RecommendedArticles from '@/components/articles/Recommended';

export default {
    components: {
        ContentBuilder,
        ArticleNavigation,
        RecommendedArticles
    },

    mixins: [headMixin],

    async asyncData({
        params: { slug },
        store: { dispatch },
        error,
        redirect,
        route
    }) {
        try {
            const article = await dispatch('articles/show', slug);

            return { article, meta: article.meta };
        } catch (err) {
            redirect({
                path: '/?modal=join',
                query: { redirect: route.path }
            });

            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    computed: {
        paragraphs() {
            const paragraphs = this.article.content
                .map((item, index) => ({ ...item, parentIndex: index }))
                .filter(
                    ({ key, value }) =>
                        (key === 'text' && value.includes('<h2')) ||
                        (key === 'double' && value.text?.includes('<h2'))
                )
                .map(paragraph => {
                    const [paragraphTitle] =
                        paragraph.key === 'text'
                            ? paragraph.value.match(/<h2(.*?)<\/h2>/g)
                            : paragraph.value.text?.match(/<h2(.*?)<\/h2>/g);

                    return { ...paragraph, value: paragraphTitle };
                });

            return paragraphs;
        }
    },

    created() {
        this.splitContentTextToParagraphs();
    },

    methods: {
        splitContentTextToParagraphs() {
            const { content } = this.article;
            const splitedContent = [];

            content.map(item => {
                if (item.key === 'text' && item.value.includes('<h2')) {
                    const splited = item.value
                        .split(/(<h2)/)
                        .filter(element => element !== '');

                    splited.forEach((element, index) => {
                        if (index === 0 && !element.includes('<h2')) {
                            splitedContent.push({
                                key: item.key,
                                value: element
                            });
                        }

                        if (element.includes('<h2')) {
                            splitedContent.push({
                                key: item.key,
                                value: element + splited[index + 1]
                            });
                        }
                    });
                } else if (item.key === 'double') {
                    let { value } = item;
                    const {
                        left: [left],
                        right: [right]
                    } = item.value;

                    const isText = left.key === 'text' || right.key === 'text';

                    if (isText) {
                        const content = [left, right];

                        for (const side of content) {
                            if (
                                side.key === 'text' &&
                                !side.value.includes('<h2')
                            ) {
                                splitedContent.push(item);
                            }

                            if (
                                side.key === 'text' &&
                                side.value.includes('<h2')
                            ) {
                                value = { ...value, text: side.value };

                                item.value = value;

                                splitedContent.push(item);
                            }
                        }
                    } else {
                        splitedContent.push(item);
                    }
                } else {
                    splitedContent.push(item);
                }
            });

            this.article.content = splitedContent.length
                ? [...splitedContent]
                : [...content];
        }
    }
};
</script>
